import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';

export function positionQtyMismatchBuilder({parsedStatusObj}) {
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        Potential quantity mismatch. Trade Unafraid quantity:{' '}
        {parsedStatusObj.tradePlanPositionQty
          ? parsedStatusObj.tradePlanPositionQty
          : 'unknown'}
        . Brokerage quantity:{' '}
        {parsedStatusObj.brokeragePositionQty
          ? parsedStatusObj.brokeragePositionQty
          : 'unknown'}
        .
      </Body3>
    </td>
  );
}
